// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: whitesmoke;
}

.file-upload-container {
    width: 100%;
    max-width: 100%;
    background-color:whitesmoke;
    padding: 20px;
    padding-left: 40px; 
    padding-right: 40px; 
    border: 1px solid #ccc;
    border-radius: 10px;
}

.bulk-upload-header {
    background-color: white;
    text-align: center;
    padding: 10px;
    font-family: "GothamBold",Arial,sans-serif;
}

.bulk-upload-file-container {
    border: 2px solid #0B2D71;
    width: 100%;
    margin: 20px auto;
    border-radius: 10px;
    background-color: #fff;
}

.bulk-upload-file-select-text {
    color: white;
    padding: 10px;
    background-color: #0B2D71;
    text-align: left;
    border-radius: 5px 5px 0 0;
    font-family: "GothamBold",Arial,sans-serif;
}

.bulk-upload-file-button-upload {
    margin: 10px 15px;
    padding: 10px;
    color: white;
  
    border-radius: 5px;
    width: max-content;
    /* font-size: 20px; */
     font-family: "GothamBold",Arial,sans-serif; 
    text-align: left;
} 

.bulk-upload-input-file {
    margin: 10px 15px;
    font-size: 14px;
    font-family: "GothamBold",Arial,sans-serif;
    background-color: #0B2D71;
    padding: 10px;
    color: white;
    border-radius: 10px;
    border: none;
    cursor: pointer;
}

button {
    background-color:  #0B2D71;
    color: white;
    border: none;
    padding: 10px 10px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
}

mat-spinner {
    margin: auto;
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./src/app/admin/bulkupload/bulkupload.component.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,YAAY;;IAEZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;KACpB,0CAA0C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,0CAA0C;IAC1C,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC","sourcesContent":["body {\n    background-color: whitesmoke;\n}\n\n.file-upload-container {\n    width: 100%;\n    max-width: 100%;\n    background-color:whitesmoke;\n    padding: 20px;\n    padding-left: 40px; \n    padding-right: 40px; \n    border: 1px solid #ccc;\n    border-radius: 10px;\n}\n\n.bulk-upload-header {\n    background-color: white;\n    text-align: center;\n    padding: 10px;\n    font-family: \"GothamBold\",Arial,sans-serif;\n}\n\n.bulk-upload-file-container {\n    border: 2px solid #0B2D71;\n    width: 100%;\n    margin: 20px auto;\n    border-radius: 10px;\n    background-color: #fff;\n}\n\n.bulk-upload-file-select-text {\n    color: white;\n    padding: 10px;\n    background-color: #0B2D71;\n    text-align: left;\n    border-radius: 5px 5px 0 0;\n    font-family: \"GothamBold\",Arial,sans-serif;\n}\n\n.bulk-upload-file-button-upload {\n    margin: 10px 15px;\n    padding: 10px;\n    color: white;\n  \n    border-radius: 5px;\n    width: max-content;\n    /* font-size: 20px; */\n     font-family: \"GothamBold\",Arial,sans-serif; \n    text-align: left;\n} \n\n.bulk-upload-input-file {\n    margin: 10px 15px;\n    font-size: 14px;\n    font-family: \"GothamBold\",Arial,sans-serif;\n    background-color: #0B2D71;\n    padding: 10px;\n    color: white;\n    border-radius: 10px;\n    border: none;\n    cursor: pointer;\n}\n\nbutton {\n    background-color:  #0B2D71;\n    color: white;\n    border: none;\n    padding: 10px 10px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n}\n\nmat-spinner {\n    margin: auto;\n    position: absolute;\n    top: 70%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
